import React, { useEffect, useState } from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import { Headings } from "../../../atoms/Headings";
import FormFields from "../../../atoms/FormFields";
import Buttons from "../../../atoms/Buttons";
import GetInTouchDocUpload from "./getintouch_docupload";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../../redux/actions";
import LoadingSpinner from "../../../atoms/Loader";
import "./getintouch-uploaddoc.scss";
import { Icons } from "../../../atoms/Icons";
import callus from "../../../assets/callus.png";
import faq from "../../../assets/faq.png";
import uploadDoc from "../../../assets/upload_doc.png";
import getInTouchIllustration from "../../../assets/getintouch_illustration.png";
import docPdf from "../../../assets/doc-pdf-purple.png";
import CustomDropdownMenu from "../../../atoms/CustomDropdownMenu";
import { documentValueOptions } from "../../../constants/constants";
import PhoneInput from "../../../atoms/PhoneInput";
import { countries, customLabels } from "../../../redux/constants";
import { ModalOverlay } from "../../../atoms/Modal";
import { UPLOAD_DOC_GETINTOUCH_RESET } from "../../../redux/actions/types";
import { ErrorMessages } from "../../../atoms/ErrorMessages";

const GetInTouchUnAuth = () => {
  const [width] = useState(window.innerWidth); //eslint-disable-line
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [showToaster, setShowToaster] = useState(false);
  const [fileToRemove, setFileToRemove] = useState(undefined);
  const [ourReference, setOurReference] = useState("");
  const [name, setName] = useState("");
  const [membershipNum, setMembershipNum] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [queryType, setQueryType] = useState("Query type");
  const [fileNames, setFileNames] = useState([]);
  const [message, setMessage] = useState("");
  const [mobileCountryCode, setMobileCountryCode] = useState("GB");
  const [mobileBorderOutline, setMobileBorderOtline] = useState("select-box");
  const [mobileNumberPending] = useState(false);
  const [mobileError, setMobileError] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [showDocError, setShowDocError] = useState(false);
  const [docErrorMsg, setDocErrorMsg] = useState("");
  const dispatch = useDispatch();
  const {
    uploadGetInTouchDocumentUnAuth, // eslint-disable-line
  } = bindActionCreators(actionCreators, dispatch);
  // eslint-disable-line
  const {
    uploadGetInTouchDocFetching,
    uploadGetInTouchDocData, // eslint-disable-line
    uploadGetInTouchDocError,
  } = useSelector((state) => state.uploadGetInTouchDocReducer);
  useEffect(() => {
    if (uploadGetInTouchDocData?.status == "success") {
      // Reset
      setFileNames([]);
      setQueryType("Query type");
      setOurReference("");
      setMessage("");
      setName("");
      setEmail("");
      setPhone("");
      setMembershipNum("");
      window.scrollTo(0, 0);
      setIsFormVisible(false);
      setShowToaster(true);
    }
  }, [uploadGetInTouchDocData]);

  const goToFAQs = () => {
    window.open("https://www.tpt.co.uk/faqs", "_blank").focus();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "TPT Get In Touch Form";
  }, []);

  const addFilesIntoList = (newFileName) => {
    setFileNames((prevState) => [...prevState, newFileName]);
  };
  const removeFiles = (item) => {
    const newFiles = fileNames.filter((file) => item !== file);
    setFileNames(newFiles);
    setFileToRemove(item);
  };
  const handleMessage = (e) => {
    const value = e.target.value;
    if (value.length <= 250) {
      setMessage(value);
    }
  };

  const handleMobileNumberChange = (e) => {
    setMobileBorderOtline("select-box-focus");
    let newValue = e.target.value
      .replace(/[^\d\s]/g, "")
      .replace(/\s{2,}/g, " ");
    setPhone(newValue);
    setMobileError("");
  };

  const handleMobileNumberFocus = () => {
    if (mobileError) {
      setMobileBorderOtline("select-box-error");
    } else {
      setMobileBorderOtline("select-box-focus");
    }
  };

  const handleMobileNumberBlur = () => {
    if (mobileError) {
      setMobileBorderOtline("select-box-error");
    } else {
      setMobileBorderOtline("select-box");
    }
  };

  const handleInputChangeEvent = (e) => {
    const targetElement = e.target.name;
    const targetValue = e.target.value;
    switch (targetElement) {
      case "Name":
        {
          setName(targetValue);
        }
        break;
      case "Membership":
        {
          setMembershipNum(targetValue);
        }
        break;
      case "Phone":
        {
          setPhone(targetValue);
        }
        break;
      case "Email":
        {
          setEmail(targetValue);
        }
        break;
      case "Our reference":
        {
          setOurReference(targetValue);
        }
        break;
      case "message":
        {
          setMessage(targetValue);
        }
        break;
      default:
    }
  };

  const handleMobileCountryCode = (countryCode) => {
    const selectedCountry = customLabels[countryCode];
    if (selectedCountry) {
      const { primary: countryName, secondary: dialCode } = selectedCountry;
      console.log("countryName ", countryName);
      console.log("dialCode ", dialCode);
    }
    setMobileCountryCode(countryCode);
  };

  const changeQueryTypeValue = (value) => {
    setQueryType(value);
  };
  const submitFormData = async () => {
    const formData = new FormData();

    let jsonEmailBody = {
      name: name,
      requestorEmail: email,
      membership: membershipNum,
      phone: phone,
      queryType: queryType,
      message: message,
      ourReference: ourReference,
    };

    formData.append("EmailObject", JSON.stringify(jsonEmailBody));
    fileNames?.forEach((fileItem) => {
      formData.append("getInTouchDoc", fileItem);
    });
    let emailValidRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line

    if (name == "" || !name.trim().length) {
      setErrorMsg("Please enter name");
      setShowError(true);
    } else if (email == "" || !email.trim().length) {
      setErrorMsg("Please enter email");
      setShowError(true);
    } else if (!emailValidRegex.test(email)) {
      setErrorMsg("Please enter valid email");
      setShowError(true);
    } else if (queryType == "Query type") {
      setErrorMsg("Please select value from Query type");
      setShowError(true);
    } else {
      setShowError(false);
      setErrorMsg("");
      window.scrollTo(0, 0);
      uploadGetInTouchDocumentUnAuth(formData);
    }
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  function byteConverter(bytes, decimals, only) {
    const K_UNIT = 1024;
    const SIZES = ["Bytes", "KB", "MB", "GB", "TB", "PB"];

    if (bytes == 0) return "0 Byte";

    if (only === "MB")
      return (bytes / (K_UNIT * K_UNIT)).toFixed(decimals) + " MB";

    let i = Math.floor(Math.log(bytes) / Math.log(K_UNIT));
    let resp =
      parseFloat((bytes / Math.pow(K_UNIT, i)).toFixed(decimals)) +
      " " +
      SIZES[i];

    return resp;
  }

  // useEffect for field validation
  useEffect(() => {
    if (showError) {
      window.scrollTo(0, 0);
    }
    setTimeout(() => {
      if (showError) {
        setShowError(false);
        setErrorMsg("");
      } else if (showDocError) {
        setShowDocError(false);
        setDocErrorMsg("");
      }
    }, 3000);
  }, [showError, showDocError]);

  // useeffect when error comes
  useEffect(() => {
    window.scrollTo(0, 0);
    setErrorMsg(
      uploadGetInTouchDocError
        ? uploadGetInTouchDocError
        : "Unable to submit details, please try again later",
    );
    setTimeout(() => {
      dispatch({ type: UPLOAD_DOC_GETINTOUCH_RESET });
    }, 5000);
  }, [uploadGetInTouchDocError]);
  return (
    <div className="getInTouch-Container-unsecured">
      <Container fluid>
        <Row>
          <Col lg={9} md={7} sm={8} xs={12}>
            <Headings pageTitle="Get in touch" />
          </Col>
        </Row>
        {(showError || uploadGetInTouchDocError) && (
          <Row className="err-container">
            <ErrorMessages
              text={`${errorMsg}`}
              className="account-alert-message"
            />
          </Row>
        )}
      </Container>

      <div className="card-container mt-4">
        <Row>
          <Col lg={9} xl={9} xs={12} sm={9} md={9}>
            <Row>
              <Col
                className="mt-2 content-padding-left"
                xs={12}
                lg={10}
                md={10}
              >
                <div className="mb-2 mt-3">
                  <span className="spanHeaderTitle">Need some help?</span>
                </div>

                <div className="div-header">
                  <span className="spanSubHeaderTitle mt-3">
                    It’s easy to get in touch. If you’ve got any questions about
                    your TPT pension please contact us using the methods below.
                  </span>
                  <br />
                  <span className="spanSubHeaderTitle">
                    Our office hours are from 8:30am to 5:30pm. Calls may be
                    recorded for training or monitoring purposes.
                  </span>
                </div>
              </Col>
              <Row className="mb-4 mt-4 ms-4 ps-4 contact-cards">
                <Col
                  lg={5}
                  md={5}
                  sm={12}
                  className="position-relative content-Center me-2"
                >
                  <Row>
                    <Col xs={3} className="image">
                      <img src={callus} className="imageSize" />
                    </Col>
                    <Col className="callus-faq-col">
                      <div className="spanHeaderComponentTitle mb-1">
                        Call Us
                      </div>
                      <div className="spanHeaderComponentSubTile">
                        <p className="callus-hybrid-text">
                          <b>0345 072 6780</b> (Defined Contribution members)
                        </p>
                      </div>
                      <div className="spanHeaderComponentSubTile">
                        <p className="callus-hybrid-text">
                          <strong>0113 234 5500</strong> (If you have both
                          Defined Contribution and Defined Benefit memberships
                          with TPT)
                        </p>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col
                  lg={5}
                  md={5}
                  sm={12}
                  className="position-relative content-Center me-2"
                >
                  <Row>
                    <Col xs={3} className="image">
                      <img src={faq} className="imageSize" />
                    </Col>
                    <Col className="callus-faq-col">
                      <div className="spanHeaderComponentTitle mb-1">FAQs</div>
                      <div className="spanHeaderComponentSubTile">
                        Before you get in touch why not check out our&nbsp;
                        <a
                          onClick={goToFAQs}
                          className="spanHeaderTxtUnderline"
                        >
                          FAQs
                        </a>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Row>
          </Col>
          <Col lg={3} xl={3} sm={3} md={3} className="illustration">
            <img
              src={getInTouchIllustration}
              className="illustration-non-secure"
            />
          </Col>
        </Row>
      </div>
      <div
        className="card-container mt-3 pb-3"
        onClick={() => {
          setIsFormVisible(!isFormVisible);
        }}
      >
        <Row className="uploadIcon">
          <Col lg={2} md={2} xs={3}>
            <div className="position-relative d-flex">
              <img src={uploadDoc} className="uploadDocImageSize" />
            </div>
          </Col>
          <Col lg={9} md={9} sm={11} xs={7}>
            <div className="position-relative d-flex ms-2">
              <div className="d-inline-block content-wrapper mt-3">
                <div className="mt-3">
                  <span className="spanHeaderUploadTitle">
                    Upload documents or send us a message
                  </span>
                </div>

                <div className="mt-3">
                  <span className="spanSubTitleUpload">
                    Click here to complete a form to upload documents or send us
                    a message.
                  </span>
                  <br />
                  <span className="spanSubTitleUpload">
                    You can respond to a letter we’ve sent you, or ask about
                    something completely new.
                  </span>
                </div>
              </div>
            </div>
          </Col>
          <Col
            lg={1}
            md={1}
            sm={1}
            xs={2}
            className="arrowIcnContainer pe-3"
            style={{ alignSelf: "center" }}
          >
            <Icons
              iconname={isFormVisible ? "arrow-up-blue" : "arrow-down-blue"}
              variant={width >= 500 ? "icon-fourty-px" : "icon-twenty-px"}
            />
          </Col>
        </Row>
      </div>

      {isFormVisible && (
        <div>
          <Card className="card-container mt-3 content-padding">
            <Card.Body>
              <Card.Title>
                <div className="parent-div">
                  <div className="left-div">{"Your details"}</div>
                </div>
                <Row>
                  <Col sm={12} xs={12} lg={6} md={6} className="mb-2">
                    <div className="position-relative getInTouch-yourDetails">
                      <FormFields
                        Label="Name"
                        disabled={false}
                        value={name}
                        changeHandler={handleInputChangeEvent}
                        name="Name"
                        placeholder=""
                        maxLength={40}
                        style={{ background: "#e9ecef" }}
                        onClick={() => {}}
                        onKeyDown={() => {}}
                      />
                    </div>
                  </Col>
                  <Col sm={12} xs={12} lg={6} md={6}>
                    <div className="position-relative">
                      <FormFields
                        Label="Membership Number (optional)"
                        disabled={false}
                        value={membershipNum}
                        changeHandler={handleInputChangeEvent}
                        name="Membership"
                        placeholder=""
                        style={{ background: "#e9ecef" }}
                        maxLength={40}
                        onClick={() => {}}
                        onKeyDown={() => {}}
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col sm={12} xs={12} lg={6} md={6} className="mb-2">
                    <div className="position-relative getInTouch-yourDetails">
                      <FormFields
                        Label="Email"
                        type="email"
                        disabled={false}
                        value={email}
                        changeHandler={handleInputChangeEvent}
                        name="Email"
                        placeholder=""
                        maxLength={40}
                        style={{ background: "#e9ecef" }}
                        onClick={() => {}}
                        onKeyDown={() => {}}
                      />
                    </div>
                  </Col>
                  <Col sm={12} xs={12} lg={6} md={6}>
                    <div className="position-relative">
                      <PhoneInput
                        value={phone}
                        label="Phone (optional)"
                        onChange={handleMobileNumberChange}
                        onFocus={handleMobileNumberFocus}
                        onBlur={handleMobileNumberBlur}
                        borderOutline={mobileBorderOutline}
                        selected={mobileCountryCode}
                        onSelect={handleMobileCountryCode}
                        customLabels={customLabels}
                        countries={countries}
                        maxLength={20}
                      />
                      {mobileError ? (
                        <span
                          className="position-absolute end-0 top-50 translate-middle-y list-icon red"
                          style={{ marginRight: "8px" }}
                        >
                          <Icons
                            iconname="form-fields-exclamation-mark"
                            variant="icon-sixteen-px"
                          />
                        </span>
                      ) : mobileNumberPending ? (
                        <span
                          className="position-absolute end-0 top-50 translate-middle-y list-icon red"
                          style={{ marginRight: "8px" }}
                        >
                          <Icons
                            iconname="form-fields-pending-non-editing"
                            variant="icon-sixteen-px"
                          />
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col sm={12} xs={12} lg={6} md={6} className="mb-2">
                    <div className="position-relative getInTouch-yourDetails">
                      <FormFields
                        Label="Our reference (optional)"
                        disabled={false}
                        value={ourReference}
                        //   variant={}
                        changeHandler={handleInputChangeEvent}
                        placeholder=""
                        name="Our reference"
                        maxLength={80}
                        style={{ background: "#e9ecef" }}
                        onClick={() => {}}
                        onKeyDown={() => {}}
                        spe
                      />
                    </div>
                  </Col>
                  <Col sm={12} xs={12} lg={6} md={6}>
                    <div className="position-relative">
                      <CustomDropdownMenu
                        dropDownData={documentValueOptions}
                        selectedItem={changeQueryTypeValue}
                        defaultValue={queryType}
                      />
                    </div>
                  </Col>
                </Row>
              </Card.Title>
            </Card.Body>
          </Card>

          <Card className="card-container mt-3 content-padding">
            <Card.Body>
              <Card.Title>
                <div className="parent-div">
                  <div className="left-div">{"Upload documents"}</div>
                </div>
                {showDocError && (
                  <ErrorMessages
                    text={`${docErrorMsg}`}
                    className="account-alert-message"
                  />
                )}
                <Row className="mb-4">
                  <Col lg={12} xs={12}>
                    <div className="position-relative addFile">
                      <GetInTouchDocUpload
                        addFilesIntoList={addFilesIntoList}
                        toRemoveFile={fileToRemove}
                        setShowDocError={setShowDocError}
                        setDocErrorMsg={setDocErrorMsg}
                      />
                    </div>
                  </Col>
                </Row>
                <div>
                  {fileNames.map((item, index) => {
                    return (
                      <div key={index} className="fileContainer">
                        <div className="file-list">
                          <div className="fileNameAndIcon">
                            <img src={docPdf} />
                            <div className="fileTextContainer">
                              <span className="fileName">{item?.name}</span>
                              <div>
                                <span className="fileDate">
                                  {formatDate(item?.lastModified)}
                                </span>{" "}
                                .{" "}
                                <span className="fileDate">
                                  {byteConverter(item?.size, 1, "MB")}
                                </span>
                              </div>
                            </div>
                          </div>
                          <Icons
                            iconname="doc-cross-red"
                            variant="icon-eighteen-px"
                            clickHandler={() => removeFiles(item)}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Card.Title>
            </Card.Body>
          </Card>

          <Card className="card-container mt-3  content-padding">
            <Card.Body>
              <Card.Title>
                <div className="parent-div">
                  <div className="left-div">{"Send us a message"}</div>
                </div>
                <Row className="mb-4">
                  <Col lg={12} xs={12}>
                    <div className="position-relative">
                      <FormFields
                        name="get in touch"
                        placeholder="Please write your message and/or explain your documents here"
                        variant={""}
                        style={{
                          height: "160px",
                          background: "#e9ecef",
                          textAlign: "left",
                          valign: "top",
                          paddingTop: "8px",
                          boxSizing: "border-box",
                          lineheight: "normal",
                          resize: "none",
                          fontFamily: "Calibri",
                          fontSize: "16px",
                        }}
                        disabled={false}
                        value={message}
                        changeHandler={handleMessage}
                      />
                      <span className="msg-max-chars">
                        Maximum 250 characters
                      </span>
                    </div>
                  </Col>
                </Row>
              </Card.Title>
            </Card.Body>
          </Card>

          <Row>
            <Col lg={6} md={6} sm={12} className="thank-you-container">
              {showToaster && (
                <div className="thankyou-message">
                  <span>Thank you for getting in touch!</span>
                  <br />
                  <span>
                    We&#39;ve sent you an email at the email address you
                    provided
                  </span>
                </div>
              )}
            </Col>
            <Col lg={6} md={6} sm={12}>
              <div style={{ float: "right" }}>
                <Buttons
                  className="primary btn-submit mt-4 mb-3"
                  name="Submit"
                  handleClick={() => {
                    submitFormData();
                  }}
                />
              </div>
            </Col>
          </Row>
        </div>
      )}
      {uploadGetInTouchDocFetching && <LoadingSpinner />}
      <ModalOverlay
        popup="FeedbackConfirm"
        show={showToaster}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setShowToaster(false);
        }}
        modaltitle="Thanks for getting in touch"
      />
    </div>
  );
};

export default GetInTouchUnAuth;
